module.exports = __webpack_public_path__ + "img/enroll-sis.7cd086e8.png";